import Repository from '../../repositories/RepositoryFactory';
const ccmMedicalNoteRepository = Repository.get('ccmMedicalNote');

export default {
  namespaced: true,
  state: {
    ccmMedicalNoteByPatientId: [],
    ccmMedicalNoteByCCMRecordId: [],
    ccmMedicalNote: null,
  },
  mutations: {
    STORE_CCM_MEDICAL_NOTE_BY_PATIENT_ID (state, payload) {
      state.ccmMedicalNoteByPatientId = payload;
    },
    STORE_CCM_MEDICAL_NOTE_BY_CCM_RECORD_ID (state, payload) {
      state.ccmMedicalNoteByCCMRecordId = payload;
    },
    STORE_CCM_MEDICAL_NOTE (state, payload) {
      state.ccmMedicalNote = payload;
    },
    UPDATE_CCM_MEDICAL_NOTE (state, payload) {
      state.ccmMedicalNote = {
        ...state.ccmMedicalNote,
        ...payload,
      };
    },
    UPDATE_CCM_MEDICAL_NOTE_IN_RECORD_LIST (state, id, payload) {
      const index = state.ccmMedicalNoteByCCMRecordId.findIndex(
        (record) => record.id === id,
      );
      if (index !== -1) {
        state.ccmMedicalNoteByCCMRecordId.splice(index, 1, {
          ...state.ccmMedicalNoteByCCMRecordId[index],
          ...payload,
        });
      }
    },
    REMOVE_CCM_MEDICAL_NOTE (state, id) {
      state.ccmMedicalNoteByCCMRecordId = state.ccmMedicalNoteByCCMRecordId.filter(record => record.id !== id);
    },
  },
  actions: {
    async getCCMMedicalNoteByPatientId ({ commit }, patientId) {
      const response = await ccmMedicalNoteRepository.getCCMMedicalNoteByPatientId(
        patientId,
      );
      commit('STORE_CCM_MEDICAL_NOTE_BY_PATIENT_ID', response.data);
    },

    async getCCMMedicalNoteByCCMRecordId ({ commit }, ccmRecordId) {
      const response =
        await ccmMedicalNoteRepository.getCCMMedicalNoteByCCMRecordId(ccmRecordId);

      var conditions = [];
      if (response.data) {
        response.data.forEach((condition) => {
          if (condition.isPrimary) {
            conditions.unshift(condition);
          } else {
            conditions.push(condition);
          }
        });
      }

      commit('STORE_CCM_MEDICAL_NOTE_BY_CCM_RECORD_ID', conditions);
    },

    async getCCMMedicalNote ({ commit }, id) {
      const response = await ccmMedicalNoteRepository.getCCMMedicalNote(id);
      commit('STORE_CCM_MEDICAL_NOTE', response.data);
    },

    async addCCMMedicalNote ({ commit }, body) {
      return await ccmMedicalNoteRepository.addCCMMedicalNote(body);
    },

    async updateCCMMedicalNote ({ commit }, request) {
      commit('UPDATE_CCM_MEDICAL_NOTE', request.body);
      commit('UPDATE_CCM_MEDICAL_NOTE_IN_RECORD_LIST', request.id, request.body);
      return await ccmMedicalNoteRepository.updateCCMMedicalNote(
        request.id,
        request.body,
      );
    },

    async deleteCCMMedicalNote ({ commit }, id) {
      commit('REMOVE_CCM_MEDICAL_NOTE', id);
      return await ccmMedicalNoteRepository.deleteCCMMedicalNote(id);
    },
  },
};
